import { StatCard } from "@design-system/StatCard/StatCard";

import { useClientApplicationsLastUsedTimeStatQuery } from "./ClientApplicationLastUsedStat.g";

type Props = {
  clientId: string;
};

export const ClientApplicationLastUsedStat = ({ clientId }: Props) => {
  const { data } = useClientApplicationsLastUsedTimeStatQuery({
    clientId,
  });

  const sessionDurationAggregate =
    data?.employeeSessions?.aggregate?.max?.updatedAt;

  const formatTimeAgo = (isoDate: string | null | undefined): string => {
    if (!isoDate) return "Never";
    const lastUsed = new Date(isoDate);
    const now = new Date();
    const diffMs = now.getTime() - lastUsed.getTime();

    if (diffMs < 0) return "In the future";

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
    }
    return "Today";
  };

  const formattedDuration = formatTimeAgo(sessionDurationAggregate);

  return (
    <StatCard icon="faClock" title="Last activity" value={formattedDuration} />
  );
};
